"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVideoChat = exports.useVideoCallRedirects = exports.default = void 0;
var _lodash = require("lodash");
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactUse = require("react-use");
var _ = require("./..");
var _utils = require("../../utils");
var _utils2 = require("./utils");
var _excluded = ["children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var VideoChatContext = /*#__PURE__*/(0, _react.createContext)({});
var useVideoChat = function useVideoChat() {
  return (0, _react.useContext)(VideoChatContext);
};
exports.useVideoChat = useVideoChat;
var useVideoCallRedirects = function useVideoCallRedirects() {
  var _useVideoChat = useVideoChat(),
    containerOffset = _useVideoChat.containerOffset,
    isVideoActive = _useVideoChat.isVideoActive,
    setIsMaximized = _useVideoChat.setIsMaximized,
    videoChatPath = _useVideoChat.videoChatPath;
  var history = (0, _reactRouterDom.useHistory)();
  var location = (0, _reactRouterDom.useLocation)();
  (0, _react.useEffect)(function () {
    setIsMaximized(!!(containerOffset !== null && containerOffset !== void 0 && containerOffset.height));
  }, [containerOffset, setIsMaximized]);
  (0, _react.useEffect)(function () {
    var isDefaultVideoPath = (0, _reactRouterDom.matchPath)(location.pathname, videoChatPath);
    if (!isVideoActive && isDefaultVideoPath) {
      history.goBack();
    }
  }, [history, isVideoActive, location]);
};
exports.useVideoCallRedirects = useVideoCallRedirects;
var pingTimerId;
var useVideo = function useVideo(_ref) {
  var appProps = _ref.appProps,
    _ref$onStart = _ref.onStart,
    onStart = _ref$onStart === void 0 ? _lodash.noop : _ref$onStart,
    _ref$onUnmountVideo = _ref.onUnmountVideo,
    onUnmountVideo = _ref$onUnmountVideo === void 0 ? _lodash.noop : _ref$onUnmountVideo,
    videoChatPath = _ref.videoChatPath,
    _ref$onConnectError = _ref.onConnectError,
    onConnectError = _ref$onConnectError === void 0 ? _lodash.noop : _ref$onConnectError;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    controlsVisible = _useState2[0],
    setControlsVisible = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = _slicedToArray(_useState3, 2),
    target = _useState4[0],
    setTarget = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    connectionId = _useState6[0],
    setConnectionId = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isVideoActive = _useState8[0],
    setIsVideoActive = _useState8[1];
  var _useState9 = (0, _react.useState)(!isVideoActive),
    _useState10 = _slicedToArray(_useState9, 2),
    isVideoCallAllowed = _useState10[0],
    setIsVideoCallAllowed = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isMaximized = _useState12[0],
    setIsMaximized = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isSubscribed = _useState14[0],
    setIsSubscribed = _useState14[1];
  var location = (0, _reactRouterDom.useLocation)();
  var isVideoPagePath = (0, _react.useMemo)(function () {
    return !!(0, _reactRouterDom.matchPath)(location.pathname, videoChatPath === null || videoChatPath === void 0 ? void 0 : videoChatPath.split('#')[0]);
  }, [location.pathname, videoChatPath]);
  var _useFullScreen = (0, _utils2.useFullScreen)(),
    isFullScreen = _useFullScreen.isFullScreen,
    toggleFullScreen = _useFullScreen.toggleFullScreen;
  var history = (0, _reactRouterDom.useHistory)();
  var _useState15 = (0, _react.useState)(),
    _useState16 = _slicedToArray(_useState15, 2),
    startCallAfter = _useState16[0],
    setStartCallAfter = _useState16[1];
  var _useAuth = (0, _.useAuth)(),
    performIdlePing = _useAuth.performIdlePing,
    user = _useAuth.user;
  var videoControlEventHandler = (0, _utils2.getControlEventHandler)(!isMaximized && !isFullScreen);
  var toggleControlsVisible = function toggleControlsVisible() {
    return setControlsVisible(function (s) {
      return !s;
    });
  };
  var startCallWith = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(target) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              startPingTimer();
              setIsVideoCallAllowed(false);
              (0, _.trackUserEvent)({
                eventName: 'Video Call Started',
                eventValues: {
                  target: (0, _utils.personName)(target)
                }
              });
              setTarget(_objectSpread({}, target));
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function startCallWith(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var startPingTimer = (0, _react.useCallback)(function () {
    pingTimerId = setInterval(function () {
      performIdlePing();
    }, _utils.IDLE_PING_FREQUENCY);
  }, []);
  var stopPingTimer = (0, _react.useCallback)(function () {
    clearInterval(pingTimerId);
    pingTimerId = null;
  }, [pingTimerId]);
  var finishCall = (0, _react.useCallback)(function () {
    if (pingTimerId) {
      stopPingTimer();
    }
    (0, _.setupHeapUser)({
      firstCallCompleted: true
    });
    (0, _.trackUserEvent)({
      eventName: 'Video Call Finished'
    });
    (0, _.identifyCio)({
      firstCallCompleted: true,
      email: user.email
    });
  }, [pingTimerId, stopPingTimer, user]);
  var _useUserVideoSession = (0, _utils2.useUserVideoSession)(target, onStart),
    apiKey = _useUserVideoSession.apiKey,
    roomId = _useUserVideoSession.roomId,
    token = _useUserVideoSession.token,
    loading = _useUserVideoSession.loading,
    isUnfinishedCall = _useUserVideoSession.isUnfinishedCall;

  // Sets video call state data to defaults
  var purgeCallState = function purgeCallState() {
    setIsVideoCallAllowed(true);
    setTarget({});
    setStartCallAfter(undefined);
    setConnectionId(undefined);
  };

  // only executes for the participant who dropped the call
  var onFinish = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              finishCall();
              _context2.next = 3;
              return (0, _utils2.deleteVideoCall)(roomId, connectionId).finally(purgeCallState);
            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function onFinish() {
      return _ref3.apply(this, arguments);
    };
  }();

  /**
   * Executes both for the participant who dropped call and participant
   * automatically disconnected. pingTimerId absence means that it is executed
   * for the participant who dropped call so no need to set any states
   * NOTE: This is not reliably fired on Safari
   */
  var onDisconnect = function onDisconnect() {
    if (!pingTimerId) {
      return;
    }
    finishCall();
    purgeCallState();
  };
  var onConnect = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(connId) {
      var _target$booking$id, _target$booking, _target$role;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return (0, _utils2.createVideoCall)(roomId, connId, (_target$booking$id = (_target$booking = target.booking) === null || _target$booking === void 0 ? void 0 : _target$booking.id) !== null && _target$booking$id !== void 0 ? _target$booking$id : null);
            case 3:
              setConnectionId(connId);
              (0, _.trackUserEvent)({
                eventName: 'Video Call Connected',
                eventValues: {
                  Role: (0, _utils.getRoleName)((_target$role = target === null || target === void 0 ? void 0 : target.role) !== null && _target$role !== void 0 ? _target$role : 0)
                }
              });
              _context3.next = 12;
              break;
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              _utils.toast.error({
                title: 'Failed to connect to video call',
                description: _context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.message
              });
              purgeCallState();
              onConnectError();
            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 7]]);
    }));
    return function onConnect(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var maximize = function maximize() {
    history.push(videoChatPath);
  };
  (0, _reactUse.useBeforeUnload)(isVideoActive, 'Your video call is in progress, are you sure? Any session notes will not be submitted.');
  (0, _utils.useUnload)(isVideoActive, function () {
    if (isVideoActive && roomId) {
      (0, _utils2.deleteVideoCall)(roomId, connectionId, true).finally(purgeCallState);
    }
  });
  (0, _react.useEffect)(function () {
    setIsVideoCallAllowed(!isVideoActive);
  }, [isVideoActive]);
  (0, _react.useEffect)(function () {
    var isActiveVideo = !!(target !== null && target !== void 0 && target.id && roomId && !isUnfinishedCall);
    if (isActiveVideo !== isVideoActive) {
      setIsVideoActive(isActiveVideo);
      if (isActiveVideo) {
        maximize();
      }
    }
  }, [target, roomId, isVideoActive]);
  (0, _react.useEffect)(function () {
    if (!isFullScreen) {
      setControlsVisible(true);
    }
  }, [isFullScreen]);
  return {
    appProps: appProps,
    controlsVisible: controlsVisible,
    isFullScreen: isFullScreen,
    isMaximized: isMaximized,
    isSubscribed: isSubscribed,
    isUnfinishedCall: isUnfinishedCall,
    isVideoActive: isVideoActive,
    isVideoCallAllowed: isVideoCallAllowed,
    isVideoPagePath: isVideoPagePath,
    maximize: maximize,
    onConnect: onConnect,
    onDisconnect: onDisconnect,
    onFinish: onFinish,
    onUnmountVideo: onUnmountVideo,
    roomDataLoading: loading,
    setIsMaximized: setIsMaximized,
    setIsSubscribed: setIsSubscribed,
    setStartCallAfter: setStartCallAfter,
    startCallAfter: startCallAfter,
    startCallWith: startCallWith,
    target: target,
    setTarget: setTarget,
    toggleControlsVisible: toggleControlsVisible,
    toggleFullScreen: toggleFullScreen,
    videoChatPath: videoChatPath,
    videoCallProps: {
      apiKey: apiKey,
      roomId: roomId,
      token: token
    },
    videoControlEventHandler: videoControlEventHandler
  };
};
var VideoChatProvider = function VideoChatProvider(_ref5) {
  var children = _ref5.children,
    props = _objectWithoutProperties(_ref5, _excluded);
  var videoProps = useVideo(props);
  var anchorProps = (0, _utils2.usePositionOffset)(videoProps.isMaximized);
  return /*#__PURE__*/_react.default.createElement(VideoChatContext.Provider, {
    children: children,
    value: _objectSpread(_objectSpread({}, videoProps), anchorProps)
  });
};
var _default = VideoChatProvider;
exports.default = _default;